import { Cart } from "@medusajs/medusa"

export const hasCartSameProducts = (cart: Readonly<Cart>) => {
  const productIds = cart.items.map((item) => item.variant.product_id)

  return productIds.some(
    (productId, index) => productIds.indexOf(productId) !== index
  )
}
